import { adminFetch } from "./_client";

// Task #3735 — admin Search Console performance dashboard client. Read-only;
// the server fetches from Google Search Console via the shared Google client.

export interface SearchConsoleMetrics {
  clicks: number;
  impressions: number;
  /** Click-through rate as a 0..1 fraction. */
  ctr: number;
  /** Average position (1 = top). */
  position: number;
}

export interface SearchConsoleDatePoint extends SearchConsoleMetrics {
  date: string;
}

export interface SearchConsoleQueryRow extends SearchConsoleMetrics {
  query: string;
}

export interface SearchConsolePageRow extends SearchConsoleMetrics {
  page: string;
}

export interface SearchConsolePerformance {
  configured: boolean;
  property: string;
  range?: { startDate: string; endDate: string; days: number };
  /** The immediately preceding equal-length window, for period-over-period deltas. */
  previousRange?: { startDate: string; endDate: string; days: number };
  totals?: SearchConsoleMetrics | null;
  /** Headline totals for the comparison window; null when unavailable. */
  previousTotals?: SearchConsoleMetrics | null;
  byDate?: SearchConsoleDatePoint[] | null;
  topQueries?: SearchConsoleQueryRow[] | null;
  topPages?: SearchConsolePageRow[] | null;
  partial?: boolean;
  failedParts?: string[];
  fetchedAt?: string;
}

export interface SearchConsoleSitemapContent {
  type?: string;
  submitted?: string;
  indexed?: string;
}

export interface SearchConsoleSitemap {
  path?: string;
  lastSubmitted?: string;
  isPending?: boolean;
  isSitemapsIndex?: boolean;
  type?: string;
  lastDownloaded?: string;
  warnings?: string;
  errors?: string;
  contents?: SearchConsoleSitemapContent[];
}

export interface SearchConsoleSitemaps {
  configured: boolean;
  property: string;
  sitemaps?: SearchConsoleSitemap[];
  coverage?: {
    sitemapCount: number;
    totalSubmitted: number;
    totalIndexed: number;
    withErrors: number;
    pending: number;
    indexedReported: boolean;
  };
  fetchedAt?: string;
}

export function fetchSearchConsolePerformance(token: string, days: 7 | 28 | 90 = 28) {
  return adminFetch<SearchConsolePerformance>(
    `/admin/seo/search-console/performance?days=${days}`,
    token,
  );
}

export function fetchSearchConsoleSitemaps(token: string) {
  return adminFetch<SearchConsoleSitemaps>("/admin/seo/search-console/sitemaps", token);
}
